<template>
    <div>
      <filters :scope="filtersScope">
      </filters>
      <ConversionsTabs></ConversionsTabs>
      <div class="row animated fadeIn">
          <div class="col-12">
              <div class="card">
                  <div class="card-header">
                      <i class="fa fa-area-chart"></i> {{ $t('statistic.by_graph') }}
                  </div>
                  <div class="card-block">
                      <div id="chart-conversion"></div>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
  import Highcharts from 'highcharts'
  import Helper from '../../../api/Helper'
  import Filters from '../../../components/Filters.vue'
  import ConversionsTabs from './ConversionsTabs.vue'
  import API from '../../../api/API'
  import Storage from '../../../api/Storage'
  import { map } from 'lodash'
  import getSymbolFromCurrency from 'currency-symbol-map'

  export default {
    name: 'ConversionGraph',
    components: {
      Filters,
      ConversionsTabs
    },
    data () {
      return {
        filtersScope: {
          monthFilter: true,
          offerFilter: true,
          byManualFilter: true
        },
        loading: false,
        Helper: Helper,
        Storage: Storage,
        chart: {
          colors: ['#f86c6b', '#4ebd74', '#64c2de'],
          chart: {
            type: 'area'
          },
          title: {
            text: null
          },
          credits: {
            enabled: false
          },
          xAxis: {
            type: 'datetime',
            labels: {
              format: '{value:%Y-%m}'
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: null
            },
            labels: {
              formatter: function () {
                return this.value
              }
            }
          },
          tooltip: {
            xDateFormat: '%Y-%m',
            pointFormat: '{series.name}1: <b>{point.y}</b><br/>'
          },
          navigation: {
            buttonOptions: {
              enabled: false
            }
          },
          plotOptions: {
            area: {
              fillOpacity: 0.3,
              marker: {
                enabled: false,
                symbol: 'circle',
                radius: 2,
                states: {
                  hover: {
                    enabled: true
                  }
                }
              }
            }
          },
          series: []
        }
      }
    },
    mounted: function () {
      this.createGraph()
      this.$root.$on('filters_load_new_data', () => {
        this.createGraph()
      })
      this.createGraph()
    },
    methods: {
      createGraph () {
        API.getGraphConversion().then(response => {
          if (response.status === 200) {
            this.renderChart(response.body)
          }
        })
      },
      renderChart (rows) {
        let approved = []
        let approvedVal = []
        let averageBill = []
        let averageBillLocal = []
        let paid = []
        let paidVal = []
        let averageBillName = this.$root.$t(`statistic.averageBill`)
        let paidName = this.$root.$t(`statistic.paid`)
        let approvedName = this.$root.$t(`statistic.approved`)
        let totals = this.$root.$t(`verbs.total`)
        let currencyOld = []
        let currencyNew = []
        map(rows, (row) => {
          currencyOld.push(row.local_currency.split(','))
          approved.push([Date.UTC(row.year, row.month - 1), row.approved_percent])
          averageBillLocal[Date.UTC(row.year, row.month - 1)] = row.local_currency.split(',').length === 1 ? `${row.average_bill_local.toFixed(2)} ${getSymbolFromCurrency(row.local_currency)}` : ' '
          approvedVal[Date.UTC(row.year, row.month - 1)] = row.approved
          paidVal[Date.UTC(row.year, row.month - 1)] = row.paid
          averageBill.push([Date.UTC(row.year, row.month - 1), row.average_bill_usd])
          paid.push([Date.UTC(row.year, row.month - 1), row.paid_percent])
        })
        currencyOld.forEach(array => {
          array.forEach(item => {
            currencyNew.push(item)
          })
        })
        let currency = currencyNew.filter((item, index) => { return currencyNew.indexOf(item) === index })
        this.chart.series = [
          {
            name: this.$root.$t(`statistic.approved`),
            data: approved
          }, {
            name: this.$root.$t(`statistic.averageBill`),
            data: averageBill
          }, {
            name: this.$root.$t(`statistic.paid`),
            data: paid
          }
        ]
        this.chart.tooltip.formatter = function () {
          if (this.series.name === averageBillName) {
            return `${this.series.name}:<br/>В местной валюте <b> ${currency.length === 1 ? (averageBillLocal[this.x]) : ''}</b><br/>В долларах <b>${this.y.toFixed(2)}$</b>`
          } else if (this.series.name === approvedName) {
            return `${this.series.name}: <b>${this.point.y} %</b><br/>${totals} <b>${approvedVal[this.x]}</b>`
          } else if (this.series.name === paidName) {
            return `${this.series.name}: <b>${this.point.y} %</b><br/>${totals} <b>${paidVal[this.x]}</b>`
          }
        }
        Highcharts.chart(`chart-conversion`, this.chart)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Graph.vue?1c1fb684